import { FC, useEffect, useMemo, useState } from 'react'

import { SiteApplicationResponseHeader } from './SiteApplicationResponseHeader'
import { SiteApplicationResponseForm } from './SiteApplicationResponseForm'
import { DLMLabelSelectorModal, DLMSiteApplication, IDLMWebROIModel, initDLMWebDOCModelValues, initDLMWebROIModelValues } from '../../../core/doclabel'
import { cloneDeep, filter } from 'lodash'
import { DLMResponseFormContextProvider, GenerateROIModal } from '../workflow/components'

type Props = {
    site: DLMSiteApplication
    workflow: string
    doClose: Function
}

const SiteApplicationResponseModal: FC<Props> = ({site, workflow, doClose}) => {

    const [baseROI, setBaseROI] = useState<IDLMWebROIModel>(cloneDeep(initDLMWebROIModelValues))
    const [genROIvisible, showGenROIModal] =  useState(false);
    const [genROIIndex, setGenROIIndex] = useState(0);
    const [onGenROI, setOnGenROI] = useState<Function | undefined>();
    const [roiHasIssueDate, setROIHasIssueDate] = useState(false);

    const [ labelSeries, setLabelSeries ] = useState(-1);
    const [ labelSelection, setLabelSelection ] = useState<Array<string> | null>(null);
    const [ targetLabels, setTargetLabels] = useState<Array<string> | null>(null);
    const [ onLabelSelect, setOnLabelSelect] = useState<Function | undefined>();

    const generateROI = (flag?: boolean) => {
        setROIHasIssueDate(flag ? true : false);
        showGenROIModal(true);
    }

    const { siteState, siteID, appID, siteROIS, siteProjectName, siteClientRefNo } = useMemo(() => {

        if (! site) return { siteState : '', siteID : 0, appID: 0, siteROIS: [], siteProjectName: '', siteClientRefNo: ''};

        const { state: siteState, id: siteID, dlmApplication, rois, projectName, clientRefNo } = site;
        const { id: appID  } = dlmApplication;

        const siteROIS = (rois && rois.length) ?  filter(rois, o => (! o?.deleted)).map( (o: any) => ({...o, siteId: siteID, roiId: o.id})): [];

        return { siteState, siteID, appID, siteROIS, siteProjectName: projectName, siteClientRefNo : clientRefNo }
    }, [site]);

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    return (
    <DLMResponseFormContextProvider
        appID={appID}
        workflow={workflow}
        appState={''}
        doClose={doClose}

        // generate DOC parameters (dummy)
        baseDOC={initDLMWebDOCModelValues}
        setBaseDOC={() => {}}
        genDOCIndex={0}
        setGenDOCIndex={() => {}}
        onGenDOC={undefined}
        setOnGenDOC={() => {}}
        generateDOC={() => {}}

        // generate ROI parameters
        baseROI={baseROI}
        setBaseROI={setBaseROI}
        genROIIndex={genROIIndex}
        setGenROIIndex={setGenROIIndex}
        onGenROI={onGenROI}
        setOnGenROI={setOnGenROI}
        generateROI={generateROI}

        labelSeries={labelSeries}
        setLabelSeries={setLabelSeries}
        labelSelection={labelSelection}
        setLabelSelection={setLabelSelection}
        targetLabels={targetLabels}
        setTargetLabels={setTargetLabels}
        onLabelSelect={onLabelSelect}
        setOnLabelSelect={setOnLabelSelect}

        siteID={siteID}
        siteState={siteState}
    >
        <div
            className='modal fade show d-block'
            id='kt_siteapplication_response_modal'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
        >
            <div className='modal-dialog modal-dialog-centered mw-600px'>
                <div className='modal-content'>
                    <SiteApplicationResponseHeader siteState={siteState} doClose={doClose} />
                    <div className='modal-body p-4'>
                        <SiteApplicationResponseForm
                            siteID={siteID}
                            siteState={siteState}
                            siteROIS={siteROIS}
                            siteProjectName={siteProjectName}
                            siteClientRefNo={siteClientRefNo}
                            appID={appID ? appID : 0}
                            workflow={workflow}
                            doClose={doClose}
                        />
                    </div>
                </div>
            </div>
        </div>
        <div className='modal-backdrop fade show'></div>
        {(genROIvisible && baseROI) && 
        <GenerateROIModal
            baseROI={baseROI}
            onSuccess={(values: any) => {
                if (onGenROI) {
                    onGenROI(values, genROIIndex);
                }                
                setGenROIIndex(-1);                
                setOnGenROI(undefined);
            }}            
            doClose={() => showGenROIModal(false)}
            hasIssueDate={roiHasIssueDate}
        />
        }
        { (labelSelection !== null && onLabelSelect !== undefined) &&
        <DLMLabelSelectorModal
            title="Select Labels Not Used"
            subTitle="Select labels found to be unused."
            labelCodes={labelSelection}
            targetLabels={targetLabels}
            doClose={() => { setLabelSelection(null)}}
            doSubmit={onLabelSelect}
            labelSeries={labelSeries}
        />
        }


    </DLMResponseFormContextProvider>
    )
}

export {SiteApplicationResponseModal}
